import { createTheme } from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";
import { Constants } from "../utils";

export const theme = createTheme({
    palette: {
        primary: {
            main: '#178BF1',
        },
        secondary: {
            main: '#1D22E6',
        },
        common: {
            white: "rgba(237, 238, 254, 1)"
        },
        error: {
            main: "#DA1717E5"
        }
    },
    typography: {
        fontFamily: 'Inter, sans-serif',
        body1: {
            fontSize: "1.6rem",
            padding: '0rem 1rem'
        },
        body2: {
            fontSize: "1.4rem",
            padding: '0rem 1rem'

        },
        h6: {
            fontSize: "1.6rem",
            fontWeight: 700,
            lineHeight: '4rem',
            padding: '0rem 1rem'

        },
        h5: {
            fontSize: "2rem",
            fontWeight: 700,
            lineHeight: '4rem',
            padding: '0rem 1rem'
        },
        h4: {
            fontSize: "2.4rem",
            fontWeight: 700,
            lineHeight: '4rem',
            padding: '0rem 1rem'
        },
        h3: {
            fontSize: "2.8rem",
            fontWeight: 700,
            lineHeight: '4rem',
            padding: '0rem 1rem'
        },
        h2: {
            fontSize: "3.2rem",
            fontWeight: 700,
            lineHeight: '4rem',
            padding: '0rem 1rem'
        },
        h1: {
            fontSize: "3.6rem",
            fontWeight: 700,
            lineHeight: '4rem',
            padding: '0rem 1rem'
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '10rem',
                    height: '5.6rem',
                    width: '90%',
                    maxWidth: `${(Constants.screenMaxWidth / 100).toPrecision(2)}.rem`,
                    fontSize: '1.4rem',
                    fontWeight: '500',
                    textTransform: 'none',
                    fontFamily: 'Inter, sans-serif'
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    fontWeight: '400',
                    width: '90%',
                    maxWidth: `${(Constants.screenMaxWidth / 100).toPrecision(2)}.rem`,
                    borderRadius: '10rem',
                    '& .MuiOutlinedInput-root': {
                        fontFamily: 'Inter, sans-serif',
                        color: '#1D1B20',
                        fontSize: '1.6rem',
                        borderRadius: '10rem',
                    },
                    '& .MuiOutlinedInput-input': {
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: '400',
                        color: '#1D1B20',
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontWeight: '400',
                    width: '100%',
                    maxWidth: `${(Constants.screenMaxWidth / 100).toPrecision(2)}.rem`,
                    borderRadius: '10rem',
                    fontFamily: 'Inter, sans-serif',
                    color: '#1D1B20',
                    fontSize: '1.6rem',
                },
                input: {
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: '400',
                    color: '#1D1B20',
                }
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '1.6rem',
                },
                shrink: {
                    lineHeight: '1.5rem',
                    fontSize: '1.2rem',
                    color: '#49454F',
                    opacity: '0.5',
                    transform: 'translate(1.7rem, -0.6rem) scale(0.9)',
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: '1.2rem',
                    color: 'red',
                    pb: -1
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: (props) => ({
                    fontSize: '1rem',
                    fontWeight: '700',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    textShadow: props.theme.shadows[1],
                }),
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    ".MuiTableCell-root": {
                        fontWeight: '700',
                    }
                }
            }
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    borderRadius: '2rem',
                    padding: '2rem',
                    paddingBottom: '0px',
                    width: "calc(100% - 4rem)"
                }
            }
        },
        MuiModal: {
            styleOverrides: {
                root: (props) => ({
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '1rem',

                    ".MuiBox-root": {
                        position: 'relative',
                        width: `calc(${Constants.screenMaxWidth}px - 6rem)`,
                        maxWidth: '100%',
                        maxHeight: '92vh',
                        backgroundColor: props.theme.palette.background.paper,
                        boxShadow: props.theme.spacing(24),
                        padding: props.theme.spacing(2),
                        borderRadius: '1rem',
                        border: 'none',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                    },
                }),
            },
        },



        MuiSelect: {
            styleOverrides: {
                root: {
                    borderRadius: '10rem',
                    width: '100%',
                },
                icon: {
                    color: '#000000', // Cor do ícone
                    fontSize: '1.8rem', // Tamanho do ícone
                    marginRight: '1rem'
                }
            },
            defaultProps: {
                IconComponent: IoIosArrowDown
            }
        },

        MuiFormControl: {
            defaultProps: {
                fullWidth: true
            },
            styleOverrides: {
                root: {
                    borderRadius: '10rem',
                    height: '5.6rem',
                    width: '90%',
                    maxWidth: `${(Constants.screenMaxWidth / 100).toPrecision(2)}.rem`,
                }
            },
        },

        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderRadius: '2rem',
                    padding: '.5rem',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '2rem',
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: (props) => ({
                    padding: '1.7rem',
                    borderRadius: '2rem',
                    marginBottom: '.2rem',
                }),
            },
        },

        MuiListItemText: {
            styleOverrides: {
                root: {
                    whiteSpace: 'normal',
                }
            }
        },

        MuiRadio: {
            styleOverrides: {
                root: {
                    '& .MuiSvgIcon-root': {
                        fontSize: '2.5rem', // Tamanho do ícone do Radio
                    },
                },
            },
        },
        //@ts-ignore
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    fontSize: "1.2rem", // Aumenta a fonte das datas
                    fontFamily: "Nexa Heavy"
                },
            },
        },

        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    width: '18px',
                    height: '18px',
                    '& .MuiSvgIcon-root': {
                        fontSize: '2.5rem',
                    },
                }
            },
        },
    }
});